import { render } from "./in-grid-content-banner.vue?vue&type=template&id=2e2eaa06"
import script from "./in-grid-content-banner.vue?vue&type=script&lang=js"
export * from "./in-grid-content-banner.vue?vue&type=script&lang=js"

import "./in-grid-content-banner.vue?vue&type=style&index=0&id=2e2eaa06&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__